export const checkImage = (image: any): string => {
	return typeof image === 'string' && image.trim() !== ''
		? image
		: 'assets/icon/AppIcon.png';
};

export const checkMedia = (media: any): string => {
	return typeof media === 'string' ? media : '';
};

export const checkString = (string: any): string => {
	return typeof string === 'string' && string.trim() !== '' ? string : '-';
};

export const checkIconSlug = (string: any): string => {
	return typeof string === 'string' &&
		string.trim() !== ''
		? string
		: 'ban';
};
